import React from "react";
import type { AccordionButtonProps } from "@chakra-ui/react";
import { AccordionButton, AccordionIcon, Box } from "@chakra-ui/react";
import type { IContentMenu } from "../../..";
import { observer } from "mobx-react-lite";
import { colors } from "../../../../../theme/colors";
import { useNavigateCustom } from "../../../../../hooks";

interface IMenuButtonProps extends AccordionButtonProps {
	subMenu?: IContentMenu[];
	menu: IContentMenu;
	isSubMenuOpen: boolean;
	onTriggerTagging?(description: string, step?: string): void;
}

const MenuButton: React.FC<IMenuButtonProps> = observer(
	({ subMenu, menu, onTriggerTagging, isSubMenuOpen, ...rest }) => {
		const navigate = useNavigateCustom();

		const handleOpenLink = (link: string, newTab?: boolean): void => {
			if (newTab) {
				window.open(link);
			} else {
				navigate(link);
			}
		};

		const onClickMenu = (): React.ReactElement | void => {
			onTriggerTagging?.(menu.label); // add analytics

			if (isSubMenuOpen && menu.link) {
				window.open(menu.link);
				return;
			}

			if (subMenu) {
				return;
			}

			if (menu.link) {
				handleOpenLink(menu.link, menu.newTab);
			}
		};

		return (
			<AccordionButton
				_hover={{ bg: "transparent" }}
				_active={{ bg: "white" }}
				_focus={{ outline: "none" }}
				p={"24px 16px"}
				{...rest}
			>
				<Box
					as="span"
					flex="1"
					onClick={onClickMenu}
					textAlign="left"
					fontFamily="VivoType"
					fontWeight={500}
					color={colors.black[500]}
				>
					{menu.label}
				</Box>
				{subMenu && <AccordionIcon boxSize="16px" />}
			</AccordionButton>
		);
	},
);

export default MenuButton;
